import { render, staticRenderFns } from "./qxtbxiangqing.vue?vue&type=template&id=570ab155&scoped=true"
import script from "./qxtbxiangqing.vue?vue&type=script&lang=js"
export * from "./qxtbxiangqing.vue?vue&type=script&lang=js"
import style0 from "./qxtbxiangqing.vue?vue&type=style&index=0&id=570ab155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ab155",
  null
  
)

export default component.exports